import { useState } from "react";
import { yearAxis } from "@/mocks/archive";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function YearTimeline() {
  const [active, setActive] = useState(0);
  const current = yearAxis[active];

  return (
    <section id="year" className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
      <Reveal>
        <SectionHead
          kicker="时间为主轴 · 逐年编年"
          title="按年份，把大势一次看全"
          desc="把当年热点压成一条年轴，滑动切换年份即可快速点开这一年都发生了什么。"
        />
      </Reveal>

      <div className="grid gap-5 lg:grid-cols-[0.55fr_1.45fr] lg:gap-8">
        {/* 年份轴选择 */}
        <Reveal>
          <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar lg:flex-col lg:overflow-visible lg:pb-0">
            {yearAxis.map((y, i) => {
              const on = i === active;
              return (
                <button
                  key={y.year}
                  type="button"
                  onClick={() => setActive(i)}
                  className={`group flex shrink-0 items-center justify-between gap-3 rounded-lg border px-4 py-3 text-left transition-colors lg:w-full ${
                    on
                      ? "border-primary-500 bg-primary-600 text-background-50"
                      : "border-background-200/80 bg-background-50 text-foreground-700 hover:border-primary-300 hover:bg-background-100"
                  }`}
                >
                  <span className="flex items-center gap-3">
                    <span className={`font-heading text-2xl font-black ${on ? "text-background-50" : "text-foreground-950"}`}>
                      {y.year}
                    </span>
                    <span className="hidden text-xs lg:block">
                      <span className="block font-medium">{y.label}</span>
                      <span className={`${on ? "text-background-200" : "text-foreground-400"}`}>{y.note}</span>
                    </span>
                  </span>
                  <i className={`ri-arrow-right-line ${on ? "text-background-50" : "text-foreground-300 lg:hidden"}`}></i>
                </button>
              );
            })}
          </div>
        </Reveal>

        {/* 对应年份事件 */}
        <Reveal delay={80}>
          <div key={current.year} className="h-full rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8">
            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200/70 pb-5">
              <div className="flex items-center gap-3">
                <span className="font-heading text-4xl font-black text-primary-600 md:text-5xl">{current.year}</span>
                <div>
                  <div className="font-heading text-lg font-bold text-foreground-950">{current.label}</div>
                  <div className="text-xs text-foreground-500">{current.note} · 全年重点整理</div>
                </div>
              </div>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-900">
                <i className="ri-calendar-line"></i>
                {current.items.length} 个关键节点
              </span>
            </div>

            <ul className="mt-5 flex flex-col gap-4">
              {current.items.map((it, i) => (
                <li key={i} className="group relative flex gap-4">
                  <span className="mt-1 flex h-6 w-16 shrink-0 items-center justify-center rounded-md bg-background-200/70 text-[11px] font-semibold text-foreground-700">
                    {it.time}
                  </span>
                  <div className="relative flex-1 pb-1">
                    <span className="absolute -left-[18px] top-2.5 h-1.5 w-1.5 rounded-full bg-accent-500 ring-4 ring-accent-100"></span>
                    <p className="text-sm leading-6 text-foreground-800 transition-colors group-hover:text-primary-700">
                      {it.title}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}